
import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";

import axios from "../../api/axios";
import { getAttributeValue } from "../../utils/utils";
import APRComment from "./APRComment.js/AprComments";
import APRmemo from "./APRComment.js/APRmemo";

const Annex7a = forwardRef(({ year, district, period, hideTableDis }, ref) => {

  const [tableData, setTableData] = useState([]);
  const [showChart, setShowChart] = useState(true);
  // const [total, setTotal] = useState(null);

  useEffect(() => {
    getData();
  }, [year, district, period]);

  useImperativeHandle(ref, () => ({
    getData: () => ({
      indicator: "Annex_7a",
      tableData
    }),
  }));


  function getData() {
    axios
      .get(`/tracker/trackedEntities?orgUnit=${district}&program=QoHFZ6cd3Nm&startDate=${year}-01-01&endDate=${year}-12-31&pageSize=5000`)
      .then(result => {

        if (result.data.instances.length > 0) {

          axios
            .get(`/tracker/events?program=QoHFZ6cd3Nm&orgUnit=${district}&startDate=${year}-01-01&endDate=${year}-12-31&pageSize=5000`)
            .then(resp => {

              const data = result.data.instances;
              const reports = resp.data.instances;

              const temps = [];

              data.forEach((key, idx) => {

                const currentReport = reports.find(rep => rep.trackedEntity === key.trackedEntity);
                let allocation = 0.00;
                let receipt = 0.00;
                let targetBen = 0;
                let actualFemale = 0;
                let actualMale = 0;

                if (currentReport) {

                  currentReport.dataValues.forEach(rep => {
                    if (rep.dataElement === "HIsJGuRVMqN") {
                      allocation += parseFloat(rep.value);
                    } else if (rep.dataElement === "k3tpjhfxiVe") {
                      receipt += parseFloat(rep.value);
                    } else if (rep.dataElement === "ijnO4FfRU6u") {
                      targetBen += parseFloat(rep.value);
                    } else if (rep.dataElement === "nAvze5yaI4Z") {
                      actualFemale += parseFloat(rep.value);
                    } else if (rep.dataElement === "PazSogYpr0w") {
                      actualMale += parseFloat(rep.value);
                    }
                  });

                }

                const dataSetTemp = {
                  no: idx + 1,
                  issues: getAttributeValue("NDPC | CRIT Critical Development and Poverty Issues", key),
                  remarks: getAttributeValue("NDPC | CRIT Description", key),
                  allocation,
                  receipt,
                  targetBen,
                  actualFemale,
                  actualMale
                };

                temps.push(dataSetTemp);
              });

              setTableData(temps);

            })
            .catch(err => console.log(err))
        }

      })
      .catch(err => console.log(err))
  }



  return (
    <div className="col-12">
      <h3>Updates on Critical Development and Poverty Issues in the Year {year}</h3>
      <div className="card">
        <div className="card-header"></div>
        <div className="card-body">

      
          <APRmemo
            year={year}
            districtId={district}
            tableCommentedId={`Annex_7a-${year}`}
            hideTableDis={hideTableDis}

          />
          <div className="table-responsive">
            <table className="table table-bordered" style={{ marginTop: '20px' }}>
              <thead style={{ backgroundColor: '#d4edda', fontWeight: 'bold', border: '1px solid #000', }}>
                <tr>
                  <th style={{ border: '1px solid #000', fontWeight: 'bold' }}>Critical Development and Poverty Issues</th>
                  <th style={{ border: '1px solid #000', fontWeight: 'bold' }}>Allocation GHS</th>
                  <th style={{ border: '1px solid #000', fontWeight: 'bold' }}>Actual Receipt GHS</th>
                  <th style={{ border: '1px solid #000', fontWeight: 'bold' }}>Number of Beneficiaries Target</th>
                  <th style={{ border: '1px solid #000', fontWeight: 'bold' }}>Number of Beneficiaries Actual</th>
                  <th style={{ border: '1px solid #000', fontWeight: 'bold' }}>Remarks</th>
                </tr>
              </thead>
              {tableData && <tbody>
                {tableData.map((row, index) => (
                  <tr key={index}>
                    <td style={{ border: '1px solid #000' }}>{row.issues}</td>
                    <td style={{ border: '1px solid #000' }}>{row.allocation.toLocaleString()}</td>
                    <td style={{ border: '1px solid #000' }}>{row.receipt.toLocaleString()}</td>
                    <td style={{ border: '1px solid #000' }}>{row.targetBen}</td>
                    <td style={{ border: '1px solid #000' }}>{row.actualFemale + row.actualMale}</td>
                    <td style={{ border: '1px solid #000' }}>{row.remarks}</td>
                  </tr>
                ))}
              </tbody>}
            </table>
          </div>
          <p className="mt-2">
            <small>Source: MPCU</small>
          </p>
          <APRComment
            data={tableData}
            year={year}
            districtId={district}
            tableCommentedId={`table17-${year}`}

          >
            {({ renderCommentInput, renderCommentList }) => (
              <>
                {renderCommentInput()}
                {renderCommentList()}
              </>
            )}
          </APRComment>
        </div>
      </div>
    </div>
  );
});

export default Annex7a;
